import { Link, usePage } from "@inertiajs/react";

import PurchaseRequestPickerWithPreview from "@/components/purchase-request-picker-with-preview";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { organizationPurchaseRequestPath } from "@/routes";
import type { DeliveryNote, SharedData } from "@/types";

interface PurchaseRequestSectionProps {
  deliveryNote: DeliveryNote;
  disabled: boolean;
  onBeforeChange: (newId: number | null) => Promise<boolean>;
}

export default function PurchaseRequestSection({
  deliveryNote,
  disabled,
  onBeforeChange,
}: PurchaseRequestSectionProps) {
  const { auth } = usePage<SharedData>().props;
  const organizationSlug = auth.current_organization?.slug ?? "";
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-base font-medium">Solicitud de Compra</h2>
        <p className="text-sm text-muted-foreground">
          {deliveryNote.has_purchase_request
            ? "Este remito está vinculado a una solicitud de compra"
            : "Vincula este remito con una solicitud de compra"}
        </p>
      </div>

      <PurchaseRequestPickerWithPreview
        value={deliveryNote.purchase_request?.id ?? null}
        disabled={disabled}
        supplierId={deliveryNote.supplier?.id}
        mode="show"
        resource={{ type: "delivery_note", id: deliveryNote.id }}
        placeholder="Buscar por número o sector..."
        onBeforeChange={onBeforeChange}
      />

      {deliveryNote.purchase_request && (
        <div className="flex items-center gap-3">
          <Badge variant="secondary">
            SC #{deliveryNote.purchase_request.request_number}
          </Badge>
          <Button variant="link" size="sm" className="h-auto p-0" asChild>
            <Link
              href={organizationPurchaseRequestPath(
                organizationSlug,
                deliveryNote.purchase_request.id,
              )}
            >
              Ver solicitud
            </Link>
          </Button>
        </div>
      )}
    </div>
  );
}
